import { cn } from '@/lib/utils';
export const DrawerHeaderBoards = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className="relative flex w-full items-center justify-center" data-sentry-component="DrawerHeaderBoards" data-sentry-source-file="drawer-partials.tsx">
    <div className={cn('text-center font-heading font-semibold text-black text-lg tracking-tight dark:text-white', className)} {...props}>
      {children}
    </div>
  </div>;